const TUTTI_V2_ROUTES = {
  root: 'tutti-v2',
  computers: 'tutti-v2/computers',
  productUpdates: 'tutti-v2/product-updates',
  computerReleaseNotes: 'tutti-v2/computer-release-notes',
  agentPackages: 'tutti-v2/agent-packages',
  // Keep the bookmarked admin location stable; the route is not the policy contract.
  computerProductionUpgrade: 'tutti-v2/host-artifact-upgrade',
} as const;

export const TUTTI_V2_NAVIGATION = {
  key: 'tutti-v2',
  title: 'TUTTI V2 运营',
  brand: {
    name: 'TUTTI V2',
    description:
      '独立的 Computer、Agent 包与 Computer Production 强制升级运营能力',
    entryRoute: TUTTI_V2_ROUTES.agentPackages,
  },
  routes: TUTTI_V2_ROUTES,
} as const;

export function adminNavigationPath(route: string) {
  return `/${route}`;
}

export function isTuttiV2NavigationPath(pathname: string) {
  const normalizedPath = pathname.replace(/^\/+|\/+$/g, '');
  return (
    normalizedPath === TUTTI_V2_NAVIGATION.routes.root ||
    normalizedPath.startsWith(`${TUTTI_V2_NAVIGATION.routes.root}/`)
  );
}
